define(function (require, exports, module) {
    'use strict';

    var removeHtml = require('../tools/string/removeHtml');
    var UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {string} responseText
     */
    function WrongResultError(stack, source, responseText) {
        UploadError.apply(this, arguments);

        this.responseText = removeHtml(responseText).trim().slice(0, 1000);
    }

    WrongResultError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: WrongResultError,
        className: 'WrongResultError',
        radarName: 'error_{SOURCE}_wrong-result',
        responseText: '',

        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }: {RESPONSE_TEXT}',

        toLogString: function () {
            var result = UploadError.prototype.toLogString.apply(this, arguments);

            result = result.replace('{RESPONSE_TEXT}', this.responseText);

            return result;
        },

        getDetails: function () {
            var details = UploadError.prototype.getDetails.apply(this, arguments);

            details.responseText = String(this.responseText);

            return details;
        },
    });

    module.exports = WrongResultError;
});
